import { render, staticRenderFns } from "./MobileCampaign.vue?vue&type=template&id=6f518428&scoped=true"
import script from "./MobileCampaign.vue?vue&type=script&lang=js"
export * from "./MobileCampaign.vue?vue&type=script&lang=js"
import style0 from "./MobileCampaign.vue?vue&type=style&index=0&id=6f518428&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f518428",
  null
  
)

export default component.exports